import { render, staticRenderFns } from "./Equipment.vue?vue&type=template&id=04660be8&scoped=true&"
import script from "./Equipment.vue?vue&type=script&lang=js&"
export * from "./Equipment.vue?vue&type=script&lang=js&"
import style0 from "./Equipment.vue?vue&type=style&index=0&id=04660be8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04660be8",
  null
  
)

export default component.exports